import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Slide } from '../models/Slide';
import { SlideItem } from '../models/Slide';
import { URL_API } from '../global/config'

@Injectable({
  providedIn: 'root'
})
export class SlideService {

//private urlEndpoint: string = 'http://172.16.7.144:3000/api/v1/slides/1/slideitems';
//private urlEndpoint: string = 'http://localhost:3000/api/v1/slides/1/slideitems';
//private urlEndpoint: string = 'http://192.168.1.15:3000/api/v1/slides/1/slideitems';
private urlEndpoint: string = URL_API.UrlApi+'/api/v1/slides/1/slideitems';

private httpHeaders = new HttpHeaders({'Content-Type': 'application/json'});


constructor(
  private http: HttpClient
) { }

getSlides(){
  return this.http.get<SlideItem[]>(this.urlEndpoint);
}

}
